import { Action } from 'redux';
import { IAPIUserInfo, IStudioInfo } from '../../../model/api-modules';
import { SystemMenuId } from '../../../model/system/menu';

export enum ReduxCommonActionType {
  LOGIN = 'COMMON_LOGIN',
  LOGOUT = 'COMMON_LOGOUT',
  SELECT_MENU_ID = 'SELECT_MENU_ID',
  STUDIO_INFO = 'STUDIO_INFO',
}
export interface ILoginAction extends Action {
  type: ReduxCommonActionType.LOGIN;
  result: IAPIUserInfo | null;
}
export interface ILogoutAction extends Action {
  type: ReduxCommonActionType.LOGOUT;
}
export interface ISelectMenuId extends Action {
  type: ReduxCommonActionType.SELECT_MENU_ID;
  result: SystemMenuId | null;
}
export interface IStudioInfoAction extends Action {
  type: ReduxCommonActionType.STUDIO_INFO;
  result: IStudioInfo | null;
}
export type CommonAction =
  | ILoginAction
  | ILogoutAction
  | ISelectMenuId
  | IStudioInfoAction;

export interface ICommonState {
  readonly userInfo: IAPIUserInfo | null;
  readonly selectMenuId: SystemMenuId | number | null;
  readonly studioInfo: IStudioInfo | null;
}
